<template>
  <section class="terms" id="terms">
    <h3>Terms and conditions</h3>
    <p class="cancelation-title">Cancelation policy</p>
    <p>Please note that hotels will not accept any changes or cancellations directly. Any change or cancellation of the hotel reservation must be sent in writing by email to Bco Congresos: {{congressEmail}}. In case of cancellation the following fees will be applied... </p>
    <router-link to="/terms">Show all terms and conditions</router-link>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['congressEmail'])
  }
}
</script>

<style lang="scss" scoped>
.terms {
  margin: 0;
  padding-bottom: 40px;
  padding-top: 60px;
  border-bottom: 1px solid #E9E9E9;

  h3 {
    margin: 0 20px;
    font-size: 20px;
    margin-bottom: 20px;
    color: $primary-black;
  }

  p.cancelation-title {
    margin: 0 20px;
    font-size: 18px;
    color: $secondary-black;
    font-weight: 600;
    margin-bottom: 10px;
  }

  p {
    margin: 0 20px;
    font-size: 15px;
    color: $secondary-black;
    margin-bottom: 20px;
  }

  a {
    margin: 0 20px;
    color: $secondary-black;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;

    &::after {
      content: url('../../assets/hotel-detail/ic_button_deactive_dropdown_active_right.svg')
    }

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (min-width: 768px) {
  .terms {
    border: none;
    // flex-basis: 50%;
    margin-bottom: 0;
    padding-bottom: 0;
    padding-right: 100px;

    h3, p, a, p.cancelation-title {
      margin: 0 0 20px;
    }

    h3 {
      font-size: 42px;
    }

    p.cancelation-title {
      font-size: 28px;
    }

    p {
      font-size: 18px;
    }

    a {
      font-size: 17px;
    }
  }
}
</style>
